import React from 'react';
import { component_tool, framework_tool } from '../../../tool'
let { WizContainer } = framework_tool;
const { WizAvatarUpload } = framework_tool;
const {
  Wizmessage
} = component_tool;
import './index.less'

class BigAvatarUpload extends WizContainer {
  constructor(props) {
    super(props);
    this.state = {
      coverBol: true
    };
  }
  componentWillMount() {
    const { value } = this.props
    if (value) {
      this.setState({ coverBol: false })
    }
  }
  propsAndStateOnChange = {
    value: this._value.bind(this)
  }

  _value(nextProps, nextState) {
    if (nextProps.value) {
      nextState.coverBol = false
      return true
    }
  }
  render() {
    const _props = {
      aspectRatio: 340 / 176,
      accept: ".jpg, .jpeg, .png",
      listType: "picture-card",
      beforeUpload: (file) => {
        Wizmessage.destroy()
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          Wizmessage.error('图片不得超过10MB!');
        }
        return isLt10M;
      },
      ...this.props
    }
    return <div className='big-pic-out'>
    <div className='big-pic-upload'>
      {this.state.coverBol ? <div className='cover-style'>
        <div className='cover-item'>
          <img className="cover-icon" src={constants.files.upload_pic_icon}></img>
        </div>
        <div className='cover-item black-font'>上传图片，请<span className="blue-font">点击这里</span></div>
        <div className='cover-item grey-font bottom-box'>注：仅支持png/jpg/jpeg/bmp文件，文件大小不超过10M</div>
      </div>
        : null}
      <WizAvatarUpload {..._props} />
    </div>
    </div>
  }
}

export default BigAvatarUpload
